<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "DS Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current ds profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'DS Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                  <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in dsTable"
                :key="row.profileId"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileId }}</div>
                </td>
                <td>
                  <div>{{ row.profileName }}</div>
                </td>
                <td>
                  <div>{{ row.dsPir }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Ds Profile Edit'"
              @close="clkCancel()"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId">{{
                    title.profileId
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      :disabled="isEditClik"
                      v-model="dsForm.profileId"
                      autocomplete="off"
                      :placeholder=" 'INTEGER<0-' + profileMaxNum + '>'"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name">{{
                    title.profileName
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      maxlength="128"
                      v-model="dsForm.profileName"
                      autocomplete="off"
                      placeholder="STRING<1-128>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="pir">{{
                    title.dsPir
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="text"
                      class="form-control"
                      id="pir"
                      v-model="dsForm.dsPir"
                      placeholder="INTEGER<64-2608832>(kbps)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>


<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileDs",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      dsForm: {
        profileId: "",
        profileName: "",
        dsPir: "",
      },

      dsTable: [],
      profileMaxNum:"2047",
    }
  },

  created() {
    this.loadDsProfile()
    this.loadProfileNum()
  },

  methods: {
    loadDsProfile() {
      get("profileds")
        .then((res) => {
          this.dsTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadProfileNum() {
      get("profilemaxnum")
        .then((res) => {
          this.profileMaxNum = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        profileId: "",
        profileName: "",
        dsPir: "",
      }

      this.dsForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.dsForm.profileId),
        profileName: this.dsForm.profileName,
        dsPir: Number(this.dsForm.dsPir),
        operate: 1,
      }

      if(this.dsForm.profileId == "")
      {
        this.showAlertBox(
              "warn",
              "Message",
              "Invalid profileID"
          )
         return 
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.dsTable.length; i++) {
          if (this.dsTable[i].profileId == newProfile.profileId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this profile id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profileds", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadDsProfile()
            /*if (this.isEditClik) {
              let editindex = this.select[0]
              this.dsTable[editindex]= newProfile
            }
            else
            {
              this.dsTable.push(newProfile)
              this.dsTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.dsTable.length; i++) {
        if (this.dsTable[i].selected) {
          this.dsForm.profileId = this.dsTable[i].profileId
          if(this.dsTable[i].profileName.match(/^INDEX_/) == null)
          {
            this.dsForm.profileName = this.dsTable[i].profileName
          }
          this.dsForm.dsPir = this.dsTable[i].dsPir
          
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 2,
        operate: 2,
      }

      for (i = 0; i < this.dsTable.length; i++) {
        if (this.dsTable[i].selected) {
          newProfile.profileId = Number(this.dsTable[i].profileId)
          del.push(post("profileds", newProfile))
          id.push(this.dsTable[i].profileId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.dsTable.length; i++) {
                if (this.dsTable[i].profileId == id[index]) {
                  this.dsTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.dsTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.dsTable[i], "selected", true)
        } else {
          this.$set(this.dsTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.dsForm.profileId != "")
        {
            let profileid = Number(this.dsForm.profileId)

           if(!isNaN(profileid))
            {
                if(profileid < 0 || profileid > Number(this.profileMaxNum))
                return "profile id must be in range 0-"+ this.profileMaxNum
            }
            else
              return "profile id must be in range 0-"+ this.profileMaxNum
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.dsForm.dsPir != "")
        {
            let dsPir = Number(this.dsForm.dsPir)
            if(!isNaN(dsPir))
            {
                if(dsPir < 64 || dsPir > 2608832)
                return "pir must be in range 64-2608832"
            }
            else
              return "pir Bw must be in range 64-2608832"
        }
      }

      if(value == 3 || value == 0)
      {
        var space=/[\s]/
        if (space.test(this.dsForm.profileName)) return "Contains illegal characters."
        else
         return nonASCIIchar(this.dsForm.profileName)
      }

      return null

    }
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>